import React from "react";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Card, Col, Row, Statistic } from "antd";

const AuthStatistic = () => (
  <Row gutter={16}>
    <Col span={8}>
      <Card variant="borderless">
        <Statistic
          title="活跃量"
          value={22.78}
          precision={2}
          valueStyle={{ color: "#3f8600" }}
          prefix={<ArrowUpOutlined />}
          suffix="%"
        />
      </Card>
    </Col>
    <Col span={8}>
      <Card variant="borderless">
        <Statistic
          title="好评反馈"
          value={11.28}
          precision={2}
          valueStyle={{ color: "#3f8600" }}
          prefix={<ArrowUpOutlined />}
          suffix="%"
        />
      </Card>
    </Col>
    <Col span={8}>
      <Card variant="borderless">
        <Statistic
          title="不满意度"
          value={9.3}
          precision={2}
          valueStyle={{ color: "#cf1322" }}
          prefix={<ArrowDownOutlined />}
          suffix="%"
        />
      </Card>
    </Col>
  </Row>
);
export default AuthStatistic;
